export default __webpack_public_path__ + "static/RecklessNeue-Light-9e9fc55b1675dc9e0015a57d472d55b3.woff";